import { put, takeLatest } from 'redux-saga/effects';
import { taskCollection } from 'collections/tasks';
import { FetchStatus } from 'data/core';
import { logger } from 'services';
import { saveHomeResponseSagaAction } from '../actions';
import { homeNormalizer } from '../schema';
import { saveHomeResponse, fetchHomeResponseError } from '../slice';
function* saveHomeResponseSaga({ payload }) {
    const response = payload;
    try {
        var _response_myTasks;
        const normalizedResponse = homeNormalizer(response);
        // Push the RAW api-shaped tasks (not the normalizr output, which flattens
        // subTasks/project to ids). The collection is the api-shape source of truth.
        taskCollection.push((_response_myTasks = response.myTasks) !== null && _response_myTasks !== void 0 ? _response_myTasks : []);
        yield put(saveHomeResponse({
            data: normalizedResponse,
            fetchStatus: FetchStatus.Loaded
        }));
    } catch (error) {
        logger.error('Unable to store home tasks', {
            error
        });
        yield put(fetchHomeResponseError());
    }
}
export const watchSaveHomeResponseSaga = function*() {
    yield takeLatest(saveHomeResponseSagaAction.type, saveHomeResponseSaga);
};
